import * as yup from 'yup';

export const selectedTableSchema = yup.object().shape({
  transNo: yup.string().default(''),
  guestName: yup.string().default(''), //.required('Name is required'),
  nationality: yup.string().default('').required('Nationality is required'),
  totalPax: yup.string().required('Total Pax is required').default('1'),
  serviceType: yup
    .string()
    .default('Dine-In')
    .required('Service Type is required'),
  guestType: yup.string().default('In-House'),
  remarks: yup.string().default(''),

  // Tax Payer Information (Optional)
  guestAccountRefID: yup.string().default(''),
  busName: yup
    .string()
    .default('')
    .when(
      [
        'taxTIN',
        'busType',
        'homeAddress',
        'province',
        'countryCode',
        'expenseType',
      ],
      {
        is: (
          taxTIN,
          busType,
          homeAddress,
          province,
          countryCode,
          expenseType,
        ) =>
          [
            taxTIN,
            busType,
            homeAddress,
            province,
            countryCode,
            expenseType,
          ].some((v) => typeof v === 'string' && v.trim() !== ''),
        then: (schema) => schema.required('Business/Person’s Name is required'),
        otherwise: (schema) => schema.notRequired(),
      },
    ),
  taxTIN: yup.string().default(''),
  busType: yup.string().default(''),
  homeAddress: yup.string().default(''),
  province: yup.string().nullable().default(''),
  countryCode: yup.string().nullable().default(''),
  expenseType: yup.string().default(''),
  vatType: yup.string().default('').default('V'),
  serviceCharge: yup.boolean().default(true),
  serviceChargeRate: yup
    .string()
    .default('0.00')
    .when('serviceCharge', {
      is: true,
      then: (schema) => schema.required('Service Charge is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
});
